import { render } from "./AkYesNoButton.vue?vue&type=template&id=142826fd"
import script from "./AkYesNoButton.vue?vue&type=script&lang=js"
export * from "./AkYesNoButton.vue?vue&type=script&lang=js"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__